import type { OrderStatus, PaymentStatus } from "../types";

export const ORDER_STATUSES: { value: OrderStatus; label: string }[] = [
  { value: "confirmed", label: "Confirmed" },
  { value: "deposit_received", label: "Deposit Received" },
  { value: "in_production", label: "In Production" },
  { value: "quality_check", label: "Quality Check" },
  { value: "ready_to_ship", label: "Ready to Ship" },
  { value: "balance_received", label: "Balance Received" },
  { value: "shipped", label: "Shipped" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
];

export const PAYMENT_STATUSES: { value: PaymentStatus; label: string }[] = [
  { value: "unpaid", label: "Unpaid" },
  { value: "partial", label: "Partial" },
  { value: "paid", label: "Paid" },
];

export const PAYMENT_TYPES = [
  { value: "deposit", label: "Deposit" },
  { value: "interim", label: "Interim" },
  { value: "balance", label: "Balance" },
  { value: "refund", label: "Refund" },
];

export const PAYMENT_METHODS = [
  "T/T",
  "PayPal",
  "Stripe",
  "L/C",
  "Western Union",
  "Check",
  "Other",
];

export const INCOTERMS = [
  "EXW",
  "FCA",
  "CPT",
  "CIP",
  "DAP",
  "DPU",
  "DDP",
  "FAS",
  "FOB",
  "CFR",
  "CIF",
];

export const ORDER_STATUS_BADGE: Record<
  OrderStatus,
  "default" | "secondary" | "destructive" | "outline"
> = {
  confirmed: "secondary",
  deposit_received: "default",
  in_production: "default",
  quality_check: "default",
  ready_to_ship: "default",
  balance_received: "default",
  shipped: "default",
  completed: "outline",
  cancelled: "destructive",
};

export const PAYMENT_STATUS_BADGE: Record<
  PaymentStatus,
  "default" | "secondary" | "destructive" | "outline"
> = {
  unpaid: "destructive",
  partial: "secondary",
  paid: "outline",
};

export function formatCurrency(amount: number, currency = "USD"): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(amount);
}

/** Next logical status in the fulfillment flow */
export const NEXT_STATUS: Partial<Record<OrderStatus, OrderStatus>> = {
  confirmed: "deposit_received",
  deposit_received: "in_production",
  in_production: "quality_check",
  quality_check: "ready_to_ship",
  ready_to_ship: "balance_received",
  balance_received: "shipped",
  shipped: "completed",
};
